/*
 * TFS (personnalisation #31) : version servie depuis la copie Avada (product-model.aio.min.js)
 * jusqu'au 31/10/2026, reprise telle quelle lors du retrait d'Avada.
 * Le composant <product-model> lui-même est défini dans deferred-media.js.
 */
/* Improve Shopify 3D product media without redeclaring the model component. */
(() => {
  const init = () => {
    const english = (document.documentElement.lang || "").toLowerCase().startsWith("en");
    document.querySelectorAll("product-model").forEach((model) => {
      if (model.dataset.tfs3dReady) return;
      model.dataset.tfs3dReady = "true";

      const poster = model.querySelector(".deferred-media__poster");
      const slide = model.closest(".slick-slide");
      if (poster) {
        poster.setAttribute("aria-label", english ? "View this product in 3D" : "Voir ce produit en 3D");
        if (slide) {
          const updateFocus = () => {
            const active = slide.classList.contains("slick-active") && slide.getAttribute("aria-hidden") !== "true";
            const value = active ? "0" : "-1";
            if (poster.getAttribute("tabindex") !== value) poster.setAttribute("tabindex", value);
          };
          const observer = new MutationObserver(updateFocus);
          observer.observe(slide, { attributes: true, attributeFilter: ["class", "aria-hidden"] });
          observer.observe(poster, { attributes: true, attributeFilter: ["tabindex"] });
          updateFocus();
        }
      }

      const configureViewer = () => {
        const viewer = model.querySelector("model-viewer");
        if (!viewer) return false;
        viewer.setAttribute("disable-zoom", "");
        viewer.setAttribute("touch-action", "pan-y");
        return true;
      };
      if (!configureViewer()) {
        const observer = new MutationObserver(() => {
          if (configureViewer()) observer.disconnect();
        });
        observer.observe(model, { childList: true });
      }

      model.addEventListener("mousedown", (event) => event.stopPropagation());
      model.addEventListener("touchstart", (event) => event.stopPropagation(), { passive: true });
      model.addEventListener("keydown", (event) => {
        if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(event.key)) {
          event.stopPropagation();
        }
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();